import { theme } from '../../../../Assets/Styles/theme'

export const styles = {
  container: {
    maxWidth: 1000,
    background:
      'linear-gradient(90.81deg, #FFF6DB 1.67%, #FFE2E5 27.53%, #FFDDE7 45.32%, #E8E8FE 97.73%)',
    borderRadius: 16,
    position: 'relative',
    marginBottom: 40,
    alignItems: 'flex-end',
    '@media screen and (max-width: 768px)': {
      alignItems: 'center',
      paddingTop: 10,
      paddingBottom: 10,
    },
  },
  title: {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: '30px',
    color: '#011533',
    paddingBottom: 10,
  },
  textContainer: {
    padding: 20,
    maxWidth: '570px',
    flexBasis: '60%',
    '@media screen and (max-width: 768px)': {
      flexBasis: 'content',
      maxWidth: '100%',
    },
  },
  buttonContainer: {
    padding: 24,
    textAlign: 'center',
    '@media screen and (min-width: 768px)': {
      position: 'absolute',
      top: '50%',
      left: '85%',
      transform: 'translate(-50%, -50%)',
      width: '200px',
      height: '100px',
    },
    '& button': {
      border: '1px solid #1D2943',
      backgroundColor: '#FFFFFF',
      borderRadius: 16,
      padding: '8px 20px',
      fontWeight: 700,
      color: '#00112B',
      '&:hover': {
        backgroundColor: '#004360',
        color: 'white',
      },
      '@media screen and (min-width: 768px)': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 110,
        height: 40,
      },
      '@media screen and (max-width: 768px)': {
        border: '1px solid #1D2943',
        backgroundColor: theme.colors.primary,
        width: '100%',
        color: 'white',
        padding: '10px 12px',
        borderRadius: 12,
      },
    },
    '@media screen and (max-width: 768px)': {
      order: 3,
      paddingTop: 0,
      width: '100%',
    },
  },
  iconContainer: {
    '@media screen and (max-width: 768px)': {
      display: 'flex',
      flexDirection: 'row-reverse',
      '& svg': {
        margin: '0 auto',
      },
      order: 2,
    },
  },
  closeBtn: {
    border: 'none',
    position: 'absolute',
    top: 10,
    right: 12,
    backgroundColor: 'transparent',
    fontWeight: 200,
    fontSize: '22px',
  },
  crossMark: {
    cursor: 'pointer',
  },
  desktopShow: {
    '@media screen and (max-width: 768px)': {
      display: 'none',
    },
  },
  mobileShow: {
    display: 'none',
    '@media screen and (max-width: 768px)': {
      display: 'block',
    },
  },
}
